var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M7.149.74a.6.6 0 0 1 .6.6V6.4h5.06a.6.6 0 1 1 0 1.2H7.75v5.06a.6.6 0 1 1-1.2 0V7.6H1.49a.6.6 0 0 1 0-1.2h5.06V1.34a.6.6 0 0 1 .6-.6",
  clipRule: "evenodd"
})));
export { SvgIconPlus as ReactComponent };